(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const instances = new Map();
  const videos = new Set();
  const animations = new Set();
  const depthSections = new Set();
  let frame = 0;
  const playAnimation = (element, keyframes, options) => {
    if (reduce.matches || window.Shopify?.designMode || !element?.animate) return;
    const animation = element.animate(keyframes, options);
    animations.add(animation);
    animation.finished.catch(() => {}).finally(() => animations.delete(animation));
  };
  const updateDepth = () => {
    frame = 0;
    depthSections.forEach(section => {
      const picture = section.querySelector('.editorial__media picture');
      if (!picture) return;
      if (reduce.matches || window.Shopify?.designMode || section.dataset.motion !== 'cinematic') {
        picture.style.transform = '';
        return;
      }
      const rect = section.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight));
      picture.style.transform = `translate3d(0,${progress * (mobile.matches ? 10 : 22)}px,0) scale(${1.045 + Math.max(0, progress) * .065})`;
    });
  };
  const scheduleDepth = () => {
    if (!frame && depthSections.size) frame = requestAnimationFrame(updateDepth);
  };
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-oravisse-section]')];
    if (scope.matches?.('[data-oravisse-section]')) roots.unshift(scope);
    roots.forEach(section => {
      if (instances.has(section)) return;
      const abort = new AbortController();
      const observers = [];
      const localVideos = [];
      const signal = abort.signal;
      const on = (target, event, fn) => target?.addEventListener(event, fn, {signal});
      const syncVideos = () => localVideos.forEach(video => video.dispatchEvent(new Event('campaign:sync')));
      section.querySelectorAll('[data-campaign-video]').forEach(video => {
        let visible = false;
        const sync = () => {
          const poster = mobile.matches ? video.dataset.posterMobile : video.dataset.posterDesktop;
          if (poster && video.getAttribute('poster') !== poster) video.poster = poster;
          if (!visible || reduce.matches || document.hidden || video.closest('[hidden]') || video.dataset.autoplay !== 'true') {
            video.pause();
            if (reduce.matches) video.classList.remove('is-playing');
            return;
          }
          const src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
          if (!src) return;
          if (video.getAttribute('src') !== src) {
            video.classList.remove('is-playing');
            video.src = src;
            video.load();
          }
          video.muted = true;
          video.play().catch(() => {});
        };
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          sync();
        }, {threshold: .12});
        observer.observe(video);observers.push(observer);
        on(video, 'playing', () => video.classList.add('is-playing'));
        on(video, 'error', () => video.classList.remove('is-playing'));
        on(video, 'campaign:sync', sync);
        on(document, 'visibilitychange', sync);
        on(mobile, 'change', sync);
        on(reduce, 'change', sync);
        videos.add(video);localVideos.push(video);
      });
      const tabs = [...section.querySelectorAll('[data-application-tab]')];
      const activate = (tab, animate = true) => {
        tabs.forEach(button => {
          const active = button === tab;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = section.querySelector(`[id="${button.getAttribute('aria-controls')}"]`);
          if (!panel) return;
          panel.hidden = !active;
          if (active && animate) playAnimation(panel, [{opacity: .45, transform: 'translateY(12px)'}, {opacity: 1, transform: 'none'}], {duration: 440, easing: 'cubic-bezier(.2,.65,.2,1)'});
        });
        syncVideos();
      };
      tabs.forEach((tab, index) => {
        on(tab, 'click', () => activate(tab));
        on(tab, 'keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {event.preventDefault();activate(tabs[next]);tabs[next].focus();}
        });
      });
      on(section, 'shopify:block:select', event => {
        const panel = event.target.closest('.application-panel');
        const tab = tabs.find(t => t.getAttribute('aria-controls') === panel?.id);
        if (tab) activate(tab, false);
      });
      section.querySelectorAll('[data-routine-filter]').forEach(button => on(button, 'click', () => {
        section.querySelectorAll('[data-routine-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelectorAll('[data-routine-category]').forEach(card => {
          card.hidden = button.dataset.routineFilter !== 'all' && card.dataset.routineCategory !== button.dataset.routineFilter;
        });
      }));
      const rail = section.querySelector('[data-review-rail]');
      section.querySelectorAll('[data-review-prev],[data-review-next]').forEach(button => on(button, 'click', () => rail?.scrollBy({left: (button.hasAttribute('data-review-next') ? 1 : -1) * rail.clientWidth * .9, behavior: reduce.matches ? 'auto' : 'smooth'})));
      if (section.dataset.motion !== 'none' && !window.Shopify?.designMode) {
        const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          reveal.unobserve(entry.target);
          playAnimation(entry.target, [{opacity: .35, transform: 'translateY(24px)'}, {opacity: 1, transform: 'none'}], {duration: 800, easing: 'cubic-bezier(.2,.65,.2,1)'});
        }), {threshold: .08});
        section.querySelectorAll('.editorial__copy,.collection-intro,.refresh-intro,.trust-value,.ritual-product,.journal-card,.section-stack__intro,.newsletter-content').forEach(element => reveal.observe(element));
        observers.push(reveal);
        if (section.dataset.motion === 'cinematic') {
          const depth = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) depthSections.add(section);
            else depthSections.delete(section);
            scheduleDepth();
          });
          depth.observe(section);observers.push(depth);
        }
      }
      instances.set(section, () => {
        abort.abort();observers.forEach(observer => observer.disconnect());
        localVideos.forEach(video => {video.pause();videos.delete(video);});
        depthSections.delete(section);instances.delete(section);
      });
    });
    const layer = document.querySelector('[data-botanical-layer]');
    const toggle = document.querySelector('[data-botanical-toggle]');
    if (layer && !layer.dataset.ready) {
      layer.dataset.ready = 'true';
      const set = paused => {
        layer.classList.toggle('is-paused', paused);
        if (toggle) {
          toggle.setAttribute('aria-pressed', String(!paused));
          toggle.textContent = paused ? window.atelierLabels?.playPetals : window.atelierLabels?.pausePetals;
        }
        try {sessionStorage.setItem('botanical-paused', String(paused));} catch {}
      };
      let initial = false;
      try {initial = sessionStorage.getItem('botanical-paused') === 'true';} catch {}
      set(initial);
      toggle?.addEventListener('click', () => set(!layer.classList.contains('is-paused')));
    }
  }
  addEventListener('scroll', scheduleDepth, {passive: true});
  addEventListener('resize', scheduleDepth, {passive: true});
  reduce.addEventListener('change', () => {animations.forEach(animation => animation.cancel());updateDepth();});
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((cleanup, section) => {if (event.target.contains(section)) cleanup();}));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
